import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { DevRoeTalk } from '#shared/lex'

type TalkValue = Omit<DevRoeTalk.Record, '$type'>

interface TalkEntry {
  rkey: string
  uri: string
  cid: string
  value: DevRoeTalk.Record
}


export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

useHead({ title: () => `Edit talk · admin` })

if (!rkey.value) {
  throw createError({ status: 404, message: 'Missing rkey.' })
}

// `watch: false` stops useFetch firing one last `/.../undefined` request
// when `navigateTo` clears `route.params.rkey` on unmount.
const { data, status } = useAdminFetch<TalkEntry>(`/api/admin/talks/${rkey.value}`, {
  watch: false,
})

async function save (value: TalkValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/talks/${rkey.value}`, {
    method: 'PUT',
    body: value,
  })
  await navigateTo('/admin/talks')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminTalkForm = _resolveComponent("AdminTalkForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit talk" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminTalkForm, {
            key: 0,
            initial: _unref(data).value,
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(status) === 'pending')
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'textarea', 'pair', 'pair', 'pair', 'text', 'pair', 'pair', 'text', 'text'],
              "width-class": ""
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})